// SHARMA CAR WASH JS
let selectedVariantId = null;

function selectPlan(planId, variantId, planName, oldPrice, price) {
  // Save global variant
  selectedVariantId = variantId;
  
  // Toggle card selected styling
  document.querySelectorAll('.plan-card').forEach(card => {
    card.classList.remove('selected');
  });
  
  const selectedCard = document.getElementById(`plan-${planId}`);
  if (selectedCard) {
    selectedCard.classList.add('selected');
  }
  
  // Enable Form section
  const formSection = document.getElementById('formSection');
  if (formSection) {
    formSection.style.opacity = '1';
    formSection.style.pointerEvents = 'auto';
  }
  
  // Update Multi-step visual state
  const step2 = document.getElementById('step2');
  if (step2) {
    step2.classList.add('active');
  }
  
  // Update Summary Box
  const summaryPlan = document.getElementById('summaryPlan');
  const summaryOld = document.getElementById('summaryOld');
  const summaryDiscount = document.getElementById('summaryDiscount');
  const summaryTotal = document.getElementById('summaryTotal');
  
  if (summaryPlan) summaryPlan.textContent = planName;
  if (summaryOld) summaryOld.textContent = `${oldPrice}€`;
  if (summaryTotal) summaryTotal.textContent = `${price}€`;
  
  if (summaryDiscount) {
    const discountVal = parseInt(oldPrice) - parseInt(price);
    summaryDiscount.textContent = `-${discountVal}€`;
  }
  
  // Scroll smoothly to form section
  setTimeout(() => {
    formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
}

function processPayment() {
  if (!selectedVariantId) {
    alert('Veuillez sélectionner une formule avant de payer.');
    return;
  }
  
  // Get inputs
  const societe = document.getElementById('societe').value.trim();
  const email = document.getElementById('email').value.trim();
  const plaque = document.getElementById('plaque').value.trim();
  const modele = document.getElementById('modele').value.trim();
  const responsable = document.getElementById('responsable').value.trim();
  const tel = document.getElementById('tel').value.trim();
  const tva = document.getElementById('tva').value.trim();
  
  // Simple validation
  if (!societe || !email || !plaque || !modele || !responsable || !tel) {
    alert('Veuillez remplir tous les champs obligatoires (*).');
    return;
  }
  
  // Set third step active
  const step3 = document.getElementById('step3');
  if (step3) {
    step3.classList.add('active');
  }
  
  // Disable checkout button while adding to cart
  const payBtn = document.getElementById('payBtn');
  if (payBtn) {
    payBtn.disabled = true;
    payBtn.textContent = 'Traitement en cours...';
  }
  
  // Build Cart API submission data
  const itemData = {
    items: [{
      id: parseInt(selectedVariantId),
      quantity: 1,
      properties: {
        'Société': societe,
        'Email Facturation': email,
        'Numéro de Plaque': plaque,
        'Modèle du Véhicule': modele,
        'Responsable': responsable,
        'Téléphone': tel,
        'Numéro TVA': tva || 'Non fourni'
      }
    }]
  };
  
  // Use Shopify Cart API
  const rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  
  fetch(`${rootPath}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(itemData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Redirect to checkout directly
    window.location.href = '/checkout';
  })
  .catch(error => {
    console.error('Error adding membership product to cart:', error);
    // Fallback: Redirect to normal checkout link if AJAX fails
    window.location.href = `/cart/${selectedVariantId}:1`;
  });
}

function scrollToForm() {
  const formSection = document.getElementById('formSection');
  if (formSection) {
    formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
